import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs, doc, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { app } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "../../styles/Dashboard.css";
const Dashboard = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const db = getFirestore(app);

  useEffect(() => {
    // comprobar si hay sesión de admin
    const isAdmin = localStorage.getItem("adminAuthenticated") === "true";
    if (!isAdmin) {
      navigate("/admin/login");
      return;
    }

    const fetchOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "orders"));
        const ordersData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const quantityTotal = data.products?.reduce((sum, item) => sum + item.quantity, 0) || 0;
          return {
            id: doc.id,
            ...data,
            name: data.shippingInfo?.name || "",
            email: data.shippingInfo?.email || "",
            address: data.shippingInfo?.address || "",
            phone: data.shippingInfo?.phone || "",
            postalCode: data.shippingInfo?.postalCode || "",
            city: data.shippingInfo?.city || "",
            country: data.shippingInfo?.country || "",
            quantityTotal,
            date: data.createdAt || "",
          };
        });
        setOrders(ordersData);
      } catch (error) {
        console.error("Error al obtener pedidos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [db, navigate]);

  const handleInputChange = (id, field, value) => {
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.id === id ? { ...order, [field]: value } : order
      )
    );
  };

  const handleSave = async (id) => {
    const orderToUpdate = orders.find((order) => order.id === id);
    if (!orderToUpdate) return;

    try {
      const orderRef = doc(db, "orders", id);
      await updateDoc(orderRef, {
        name: orderToUpdate.name,
        email: orderToUpdate.email,
        address: orderToUpdate.address,
        status: orderToUpdate.status,
      });
      alert("Pedido actualizado correctamente");

      // Llamar al endpoint /order-status para enviar email
      fetch("https://patient-rain-0155.dev-bd1.workers.dev/order-status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: orderToUpdate.id,
          status: orderToUpdate.status,
          customerName: orderToUpdate.name,
          customerEmail: orderToUpdate.email,
          phone: orderToUpdate.phone,
          books: orderToUpdate.products,
          total: orderToUpdate.total,
          date: orderToUpdate.date,
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Error enviando email de estado");
          console.log("Email de estado enviado correctamente");
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error("Error al actualizar pedido:", error);
      alert("Error al actualizar pedido");
    }
  };

  // Eliminar pedido
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "orders", id));
      setOrders((prevOrders) => prevOrders.filter((order) => order.id !== id));
      alert("Pedido eliminado correctamente");
    } catch (error) {
      console.error("Error al eliminar pedido:", error);
      alert("Error al eliminar pedido");
    }
  };

  // Archivar pedido
  const handleArchive = async (id) => {
    const orderToArchive = orders.find((order) => order.id === id);
    if (!orderToArchive) return;
    try {
      await setDoc(doc(db, "archived_orders", id), orderToArchive);
      await deleteDoc(doc(db, "orders", id));
      setOrders((prevOrders) => prevOrders.filter((order) => order.id !== id));
      alert("Pedido archivado correctamente");
    } catch (error) {
      console.error("Error al archivar pedido:", error);
      alert("Error al archivar pedido");
    }
  };

  if (loading) {
    return <p className="text-center p-8">Cargando pedidos...</p>;
  }

  // Handler para cerrar sesión
  const handleLogout = () => {
    localStorage.removeItem("adminAuthenticated");
    navigate("/admin/login");
  };

  return (
    <div className="dashboard-container">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <h1 className="text-3xl font-serif text-center" style={{ marginBottom: 0 }}>📦 Panel de Pedidos</h1>
        <button
          onClick={handleLogout}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          style={{ marginLeft: "1rem" }}
        >
          Cerrar sesión
        </button>
      </div>
      {orders.length === 0 ? (
        <p className="dashboard-empty">No hay pedidos registrados.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="dashboard-table">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border"># Pedido</th>
                <th className="px-4 py-2 border">Cliente</th>
                <th className="px-4 py-2 border">Email</th>
                <th className="px-4 py-2 border">Teléfono</th>
                <th className="px-4 py-2 border">Dirección</th>
                <th className="px-4 py-2 border">Ciudad</th>
                <th className="px-4 py-2 border">Código Postal</th>
                <th className="px-4 py-2 border">Fecha</th>
                <th className="px-4 py-2 border">Productos</th>
                <th className="px-4 py-2 border">Cantidad total</th>
                <th className="px-4 py-2 border">Total (€)</th>
                <th className="px-4 py-2 border">Estado</th>
                <th className="px-4 py-2 border">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border">{order.id}</td>
                  <td className="px-4 py-2 border">
                    <input
                      type="text"
                      value={order.name || ""}
                      onChange={(e) => handleInputChange(order.id, "name", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                      placeholder="Sin nombre"
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <input
                      type="email"
                      value={order.email || ""}
                      onChange={(e) => handleInputChange(order.id, "email", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <input
                      type="text"
                      value={order.phone || ""}
                      onChange={(e) => handleInputChange(order.id, "phone", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                      placeholder="Teléfono"
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <input
                      type="text"
                      value={order.address || ""}
                      onChange={(e) => handleInputChange(order.id, "address", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <input
                      type="text"
                      value={order.city || ""}
                      onChange={(e) => handleInputChange(order.id, "city", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                      placeholder="Ciudad"
                    />
                  </td>
                  <td className="px-4 py-2 border">{order.postalCode}</td>
                  <td className="px-4 py-2 border">
                    {order.date ? new Date(order.date).toLocaleDateString() : ""}
                  </td>
                  <td className="px-4 py-2 border text-sm">
                    {order.products?.map((item, idx) => (
                      <div key={idx}>
                        {item.name} x {item.quantity} ({(item.price / 100).toFixed(2)}€)
                        {item.ISBN && item.price > 0 ? (
                          <span style={{ display: "block", color: "#555", fontSize: "0.92em" }}>
                            ISBN: {item.ISBN}
                          </span>
                        ) : null}
                      </div>
                    ))}
                  </td>
                  <td className="px-4 py-2 border font-semibold">{order.quantityTotal}</td>
                  <td className="px-4 py-2 border font-semibold">{(order.total / 100).toFixed(2)} €</td>
                  <td className="px-4 py-2 border">
                    <select
                      value={order.status || "Pendiente"}
                      onChange={(e) => handleInputChange(order.id, "status", e.target.value)}
                      className="w-full border rounded px-2 py-1"
                    >
                      <option value="Pendiente">Pendiente</option>
                      <option value="Preparando">Preparando</option>
                      <option value="Enviado">Enviado</option>
                      <option value="Recibido">Recibido</option>
                    </select>
                  </td>
                  <td className="px-4 py-2 border">
                    <div className="flex gap-3 justify-center items-center">
                      <button
                        onClick={() => handleSave(order.id)}
                        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
                      >
                        Guardar
                      </button>
                      <button
                        onClick={() => handleDelete(order.id)}
                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 ml-2"
                      >
                        Eliminar
                      </button>
                      {order.status === "Recibido" && (
                        <button
                          onClick={() => handleArchive(order.id)}
                          className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-500 ml-2"
                        >
                          Archivar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Dashboard;